import { useEffect, useRef } from 'react';
import HeroSection from './HeroSection';
import FavoriteGames from './FavoriteGames';
import Achievements from './Achievements';
import Teammates from './Teammates';
import GiftSection from './GiftSection';

interface ResultsPageProps {
  username: string;
}

export default function ResultsPage({ username }: ResultsPageProps) {
  const sectionsRef = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fadeInUp');
          }
        });
      },
      { threshold: 0.1 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen">
      <div ref={(el) => el && (sectionsRef.current[0] = el)}>
        <HeroSection username={username} />
      </div>
      
      <div ref={(el) => el && (sectionsRef.current[1] = el)} className="opacity-0">
        <FavoriteGames />
      </div>
      
      <div ref={(el) => el && (sectionsRef.current[2] = el)} className="opacity-0">
        <Achievements />
      </div>
      
      <div ref={(el) => el && (sectionsRef.current[3] = el)} className="opacity-0">
        <Teammates />
      </div>
      
      <div ref={(el) => el && (sectionsRef.current[4] = el)} className="opacity-0">
        <GiftSection />
      </div>
    </div>
  );
}
